import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Mail, ArrowLeft, Check } from "lucide-react";
import { LogoWordmark } from "../components/Logo";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email: email.trim() });
            setSubmitted(true);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Impossibile inviare la richiesta");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col p-6 sm:p-10 lg:p-16 grid-bg bg-white">
            <LogoWordmark />
            <div className="flex-1 flex items-center justify-center">
                <div className="w-full max-w-md fade-up" data-testid="forgot-password-page">
                    <Link
                        to="/login"
                        className="inline-flex items-center gap-1.5 text-sm font-bold text-[#0C4650] hover:text-[#091f26] mb-4"
                        data-testid="back-to-login"
                    >
                        <ArrowLeft className="w-4 h-4" /> Torna al login
                    </Link>

                    {!submitted ? (
                        <>
                            <h1 className="text-3xl sm:text-4xl font-extrabold text-[#0C4650] leading-tight">
                                Password dimenticata?
                            </h1>
                            <p className="mt-3 text-gray-600">
                                Inserisci l'email del tuo profilo Scintilla Hub: ti invieremo un
                                link per impostare una nuova password.
                            </p>
                            <form onSubmit={submit} className="mt-6 space-y-4">
                                <div>
                                    <label className="label">Email</label>
                                    <input
                                        type="email"
                                        className="input"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        autoFocus
                                        placeholder="tu@scintillahub.com"
                                        data-testid="forgot-email"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading || !email.trim()}
                                    className="btn-primary w-full"
                                    data-testid="forgot-submit"
                                >
                                    {loading ? (
                                        <Loader2 className="w-4 h-4 animate-spin" />
                                    ) : (
                                        <Mail className="w-4 h-4" />
                                    )}
                                    Invia il link di reset
                                </button>
                            </form>
                        </>
                    ) : (
                        <div data-testid="forgot-submitted">
                            <div className="w-16 h-16 rounded-full bg-[#C7FF2C] flex items-center justify-center">
                                <Check className="w-8 h-8 text-[#0C4650]" strokeWidth={3} />
                            </div>
                            <h1 className="mt-5 text-3xl sm:text-4xl font-extrabold text-[#0C4650] leading-tight">
                                Controlla la tua email
                            </h1>
                            <p className="mt-3 text-gray-600">
                                Se l'indirizzo <strong>{email}</strong> è registrato nel sistema,
                                riceverai a breve un'email con il link per reimpostare la
                                password. Il link è valido per 60 minuti.
                            </p>
                            <p className="mt-4 text-xs text-gray-500">
                                Non vedi nulla? Controlla anche la cartella spam, o riprova fra
                                qualche minuto.
                            </p>
                            <Link
                                to="/login"
                                className="mt-6 btn-outline w-full inline-flex"
                                data-testid="go-login-after-submit"
                            >
                                Torna al login
                            </Link>
                        </div>
                    )}
                </div>
            </div>
            <div className="text-xs text-gray-400 mt-8">
                © {new Date().getFullYear()} Scintilla Hub — Accendiamo connessioni.
            </div>
        </div>
    );
}
